<template>
    <v-row><!--class="d-none d-lg-block"-->
        <v-col class="px-5">
            <v-data-table class="mt-4 rounded elevation-3" :expanded="tabel.laiendatud" :headers="tabel.paised" :items="elemendid"
                :items-per-page="tabel.lehePikkus" :loading="laeb" show-expand fixed-header single-expand item-key="id">
                <template v-slot:[`item.tahtaegKp`]="{ value }">
                    {{ formateeriKuupaev(value) }}
                </template>
                <template #expanded-row="{ columns, item }">
                    <tr>
                        <td :colspan="columns.length">
                            <p class="mt-4 font-weight-bold">Kehtivad broneeringud</p>
                            <BroneeringuTabel :elemendid="(item.kehtivadBroneeringud as any)" :aluseId="aluseId" :broneeringuId="broneeringuId"
                :ajakavaId="ajakavaId">
                            </BroneeringuTabel>
                            <p class="font-weight-bold">Üldkasuliku töö tundide asendamine</p>
                            <UKTTundideAsendamiseTabel :elemendid="(item.tundideAsendamised as any)">
                            </UKTTundideAsendamiseTabel>
                            <p class="font-weight-bold">Lõppenud broneeringud</p>
                            <BroneeringuTabel :elemendid="(item.loppenudBroneeringud as any)" :aluseId="aluseId" :broneeringuId="broneeringuId"
                :ajakavaId="ajakavaId">
                            </BroneeringuTabel>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
    <v-row class="d-lg-none d-none">
        <v-col class="px-5">
            <v-card color="primary" title="Arvel olemise alused">
                <v-skeleton-loader type="article" v-if="laeb"></v-skeleton-loader>
                <v-data-iterator :items="annaAlused" item-value="lahendiNr">
                    <template v-slot:default="{ items }">
                        <v-row>
                            <v-col class="w-100" cols="auto" v-for="item in items" :key="item.raw.lahendiNr">
                                <v-card class="mx-auto">
                                    <template v-slot:title>
                                        Lahendi nr.: {{ item.raw.lahendiNr }}
                                    </template>
                                    <template v-slot:prepend>
                                        <v-btn v-if="aluseId" @click="$router.push({ name: 'uldkasulik_Too' });"
                                            icon="mdi-chevron-left"></v-btn>
                                    </template>
                                    <template v-slot:append>
                                        <v-btn v-if="!aluseId"
                                            @click="$router.replace({ name: 'uldkasulik_Too', params: { ajakavaRidaId: [item.raw.id] } });"
                                            icon="mdi-chevron-right"></v-btn>
                                    </template>
                                    <v-expansion-panels>
                                        <v-expansion-panel :title="item.raw.arvelOlemiseAlus">
                                            <v-expansion-panel-text>
                                                <v-list :lines="false" density="compact">
                                                    <v-list-item :title="formateeriKuupaev(item.raw.tahtaegKp)">
                                                        <template v-slot:title="{ title }">
                                                            <b>ÜKT tähtaeg:</b> {{ title }}
                                                        </template>
                                                    </v-list-item>
                                                    <v-list-item :title="item.raw.aegaLopuni">
                                                        <template v-slot:title="{ title }">
                                                            <b>Aega lõpuni:</b> {{ title }}
                                                        </template></v-list-item>
                                                    <v-list-item :title="item.raw.maaratud">
                                                        <template v-slot:title="{ title }">
                                                            <b>Määratud:</b> {{ title }}
                                                        </template></v-list-item>
                                                    <v-list-item :title="item.raw.sooritatud">
                                                        <template v-slot:title="{ title }">
                                                            <b>Sooritatud:</b> {{ title }}
                                                        </template></v-list-item>
                                                    <v-list-item :title="item.raw.sooritamata">
                                                        <template v-slot:title="{ title }">
                                                            <b>Sooritamata:</b> {{ title }}
                                                        </template></v-list-item>
                                                </v-list>
                                            </v-expansion-panel-text>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-iterator>
            </v-card>
        </v-col>
    </v-row>
    <v-row class="d-lg-none d-none" v-if="elemendidOlemas(annaKehtivadBroneeringud) && aluseId">
        <v-col class="px-5">
            <v-card color="primary" title="Kehtivad broneeringud">
                <BroneeringuTabel :aluseId="aluseId" :broneeringuId="broneeringuId" :ajakavaId="ajakavaId"
                    :elemendid="annaKehtivadBroneeringud"> </BroneeringuTabel>
            </v-card>
        </v-col>
    </v-row>
    <template v-if="broneeringuId">
        <template v-for="(element, i) in annaKehtivadBroneeringud" v-bind:key="i">
            <v-row class="d-lg-none d-none">
                <v-col class="px-5">
                    <v-card color="primary" title="Ajakavad">
                        <AjakavaTabel :aluseId="aluseId" :broneeringuId="broneeringuId" :ajakavaId="ajakavaId"
                            class="d-lg-none" :elemendid="annaAjakavad(element)"></AjakavaTabel>
                    </v-card>
                </v-col>
            </v-row>
            <template v-if="ajakavaId">
                <template v-for="(ajakava, i) in annaAjakavad(element)" v-bind:key="i">
                    <v-row class="d-lg-none d-none" v-if="ajakava.ajakavaList">
                        <v-col class="px-5">
                            <v-card color="primary" title="Ajakava">
                                <AjakavaRidaTabel :aluseId="aluseId" :broneeringuId="broneeringuId"
                                    :ajakavaId="ajakavaId" class="d-lg-none" :elemendid="ajakava.ajakavaList">
                                </AjakavaRidaTabel>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>

            </template>
        </template>
    </template>

    <v-row class="d-lg-none d-none" v-if="elemendidOlemas(annaTundideAsendamised) && aluseId && !broneeringuId">
        <v-col class="px-5">
            <v-card color="primary" title="Üldkasuliku töö tundide asendamine">
                <UKTTundideAsendamiseTabel :elemendid="(annaTundideAsendamised as any)"> </UKTTundideAsendamiseTabel>
            </v-card>
        </v-col>
    </v-row>
    <v-row class="d-lg-none d-none" v-if="elemendidOlemas(annaLoppenudBroneeringud) && aluseId">
        <v-col class="px-5">
            <v-card color="primary" title="Lõppenud broneeringud">
                <BroneeringuTabel :aluseId="aluseId" :broneeringuId="broneeringuId" :ajakavaId="ajakavaId"
                    :elemendid="annaLoppenudBroneeringud"> </BroneeringuTabel>
            </v-card>
        </v-col>
    </v-row>
    <template v-if="broneeringuId">
        <v-row class="d-lg-none d-none" v-for="(element, i) in annaLoppenudBroneeringud" v-bind:key="i">
            <v-col class="px-5">
                <v-card color="primary" title="Ajakavad">
                    <AjakavaTabel :aluseId="aluseId" :broneeringuId="broneeringuId" :ajakavaId="ajakavaId"
                        class="d-lg-none" :elemendid="annaAjakavad(element)"></AjakavaTabel>
                </v-card>
            </v-col>
        </v-row>
    </template>
</template>

<style scoped></style>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import BroneeringuTabel from '../uldine/BroneeringuTabel.vue';
import AjakavaTabel from '../uldine/AjakavaTabel.vue';
import AjakavaRidaTabel from '../uldine/AjakavaRidaTabel.vue';
import mixin from '../../core/mixins';
import { BroneeringListItem, TegevuseAjakavaListItem, TundideAsendamineListItem, UldkasulikToo } from '../../models/UldkasulikToo';
import UKTTundideAsendamiseTabel from '../uldine/UKTTundideAsendamiseTabel.vue';

export default defineComponent({
    name: 'UldkasulikTooTabel',
    components: { BroneeringuTabel, UKTTundideAsendamiseTabel, AjakavaTabel, AjakavaRidaTabel },
    props: {
        elemendid: Array as PropType<Array<UldkasulikToo>>,
        laeb: Boolean as PropType<boolean>,
        aluseId: Number as PropType<Number>,
        broneeringuId: Number as PropType<Number>,
        ajakavaId: Number as PropType<Number>,
    },
    watch: {
        aluseId: {
            handler: function () {
                this.uuendaLaiendatud();
            },
            deep: true
        },
    },
    computed: {
        annaAlused(): Array<UldkasulikToo> | undefined {
            if (!this.aluseId) return this.elemendid;

            return this.elemendid?.filter((element) => {
                return element.id === this.aluseId;
            });
        },
        annaKehtivadBroneeringud(): BroneeringListItem[] | undefined {
            if (!this.aluseId || !this.elemendid) return undefined;

            let alus = this.annaAlused?.[0];
          
            return alus?.kehtivadBroneeringud?.filter((element) => {
                return this.broneeringuId ? element.id === this.broneeringuId : true;
            });
        },
        annaTundideAsendamised(): TundideAsendamineListItem[] | undefined {
            if (!this.aluseId || !this.elemendid) return undefined;
            let alused = this.annaAlused?.[0];
            return alused?.tundideAsendamised ?? undefined;
        },
        annaLoppenudBroneeringud(): BroneeringListItem[] | undefined {
            if (!this.aluseId || !this.elemendid) return undefined;

            let alus = this.annaAlused?.[0];

            return alus?.loppenudBroneeringud?.filter((element) => {
                return this.broneeringuId ? element.id === this.broneeringuId : true;
            });
        }
    },
    mounted: function () {
        this.uuendaLaiendatud();
    },
    methods: {
        uuendaLaiendatud() {
            this.tabel.laiendatud = [];
            if (this.aluseId) this.tabel.laiendatud.push(this.aluseId);
        },
        annaAjakavad(element: BroneeringListItem): Array<TegevuseAjakavaListItem> | undefined {
            return element?.yktAjakavad?.filter((element) => {
                return this.ajakavaId ? element.id === this.ajakavaId : true;
            });
        },
        elemendidOlemas(massiiv: any[] | undefined): boolean {
            return (massiiv && massiiv.length > 0) as boolean;
        },
    },
    data() {
        return {
            tabel: {
                laiendatud: [] as Array<any>,
                paised: [
                    {
                        title: '',
                        key: 'data-table-expand',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        }
                    },
                    {
                        title: 'Lahendi nr.',
                        sortable: false,
                        width: 130,
                        key: 'lahendiNr',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                    {
                        title: 'Arvel olemise alus',
                        sortable: false,
                        width: 370,
                        key: 'arvelOlemiseAlus',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                    {
                        title: 'ÜKT tähtaeg',
                        sortable: false,
                        width: 120,
                        key: 'tahtaegKp',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                    {
                        title: 'Aega lõpuni',
                        sortable: false,
                        width: 120,
                        key: 'aegaLopuni',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                    {
                        title: 'Määratud',
                        sortable: false,
                        width: 120,
                        key: 'maaratud',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                    {
                        title: 'Sooritatud',
                        sortable: false,
                        width: 120,
                        key: 'sooritatud',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                    {
                        title: 'Sooritamata',
                        sortable: false,
                        width: 120,
                        key: 'sooritamata',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary'
                        },
                    },
                ],
                lehePikkus: 25
            },
        }
    },
    mixins: [mixin],
});
</script>
